import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import locale from "@aligov/global-locale";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import th_TH from "antd/locale/th_TH";

import App from "./App";
import { store } from "./store";
import "./i18n/config";
// import { useTranslation } from "react-i18next";

/**
 * axios 全局配置
 * */
import "./axios.config";

const AppWithLocale = () => {
  // 设置antd组件多语言
  const { lang } = locale.getLocale();
  // console.log("****lang", lang, locale.getLocale());
  // const { i18n } = useTranslation();
  const localelng = lang === "en-US" ? enUS : lang === "th-TH" ? th_TH : zhCN;

  return (
    <Provider store={store}>
      <ConfigProvider locale={localelng}>
        <App />
      </ConfigProvider>
    </Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("owtb-root"));

root.render(<AppWithLocale />);
